import ConstructionIcon from '@mui/icons-material/Construction'
import { Box, Typography, useTheme } from '@mui/material'
import { FC } from 'react'

type UnderConstructionProps = {
  /** The name of the feature being built */
  featureName: string
  /** Optional description of what the feature will do */
  description?: string
  /** Optional custom icon to display instead of the construction icon */
  icon?: React.ReactNode
}

/**
 * Placeholder component for features that are under development.
 * Use this to indicate to users that a feature is coming soon.
 */
const UnderConstruction: FC<UnderConstructionProps> = ({
  featureName,
  description,
  icon
}) => {
  const theme = useTheme()
  const iconColor = theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: 300,
        gap: 2,
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {featureName}
      </Typography>

      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, textAlign: 'center' }}>
          {description}
        </Typography>
      )}

      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Typography sx={{ color: iconColor }}>Under Construction</Typography>
        {icon || <ConstructionIcon sx={{ height: 150, width: 150, color: iconColor }} />}
      </Box>
    </Box>
  )
}

export default UnderConstruction
